// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  isLoading = new BehaviorSubject<boolean>(false);
  private requestCount = 0;
  private forceDisabled = false;

  show() {
    if (this.forceDisabled) return;
    this.requestCount++;
    queueMicrotask(() => {
      if (this.requestCount > 0) {
        this.isLoading.next(true);
      }
    });
  }

  hide() {
    if (this.forceDisabled) return;
    this.requestCount--;
    queueMicrotask(() => {
      if (this.requestCount <= 0) {
        this.requestCount = 0;
        this.isLoading.next(false);
      }
    });
  }

  disable() {
    this.forceDisabled = true;
    this.requestCount = 0; // Reset counter so hide() won't misfire
    this.isLoading.next(false);
  }

  enable() {
    this.forceDisabled = false;
  }
}

